<template>
    <section>
        <sy-baselist
                ref="roleList"
                title="角色"
                :hideHeader="true"
                :fixWhere="fixWhere"
                @beforeDelete="beforeDelete"
                @beforeAdd="beforeAddRole"
                editVue="system/Role_Edit.vue"
                listUrl="server/system/Role.ashx?cmd=GetRoleList"
                deleteUrl="server/system/Role.ashx?cmd=DeleteRole"
        >
            <el-table-column prop="FName" label="角色" width="150" sortable>
            </el-table-column>

        </sy-baselist>
    </section>
</template>

<script>
    import util from '../../common/util'
    export default {
        data(){
            return {
                FRoleID:0,
                staffOrAdmin:0,
            }
        },
        watch: {
            '$route' (to, from) {
                // 对路由变化作出响应...
                this.staffOrAdmin = this.$router.currentRoute.query.staffOrAdmin
            }
        },
        computed:{
           fixWhere(){
               return "FStaffOrAdmin=" + (this.staffOrAdmin?this.staffOrAdmin:0)
           }
        },
        methods:{
            beforeDelete(row,r){
                if(row.FIsSystem == 1) {
                    return r.error = "系统内置角色，不能删除";
                }
            },
            beforeAddRole(row,r){
                row.FStaffOrAdmin = this.staffOrAdmin
            }
        },
        created(){
           this.staffOrAdmin = this.$router.currentRoute.query.staffOrAdmin
       }
    }
</script>


// WEBPACK FOOTER //
// src/pages/system/Role.vue